var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAxs0)",
    d: "M5.263 7.556c.497-.639 4.213 1.393 6.103 3.15a.21.21 0 0 1-.013.317l-.6.501a.215.215 0 0 1-.261.009l-1.235-.887l-1.474 1.568c-.146.15-.407.467-.587.339a.81.81 0 0 1-.223-.921c.232-.536 1.462-1.66 1.462-1.66c-.618-.492-1.886-.955-2.11.614c-.145 1.02-.11 5.207 1.672 4.2c1.715-.973 8.55-8.546 9.918-7.886c1.367.656 1.842 7.886.818 9.197c-.334.429-2.563.154-6.107-2.837a.215.215 0 0 1-.013-.313l.6-.587a.215.215 0 0 1 .3-.004c.806.703 3.742 2.957 4.059 1.444c.21-1.011.231-5.498-.793-5.168c-.557.18-1.543.977-2.28 1.607c-1.599 1.371-7.243 7.572-8.554 6.844c-1.312-.724-1.63-8.314-.686-9.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAxs1)",
    d: "M5.263 7.556c.497-.639 4.213 1.393 6.103 3.15a.21.21 0 0 1-.013.317l-.6.501a.215.215 0 0 1-.261.009l-1.235-.887l-1.474 1.568c-.146.15-.407.467-.587.339a.81.81 0 0 1-.223-.921c.232-.536 1.462-1.66 1.462-1.66c-.618-.492-1.886-.955-2.11.614c-.145 1.02-.11 5.207 1.672 4.2c1.715-.973 8.55-8.546 9.918-7.886c1.367.656 1.842 7.886.818 9.197c-.334.429-2.563.154-6.107-2.837a.215.215 0 0 1-.013-.313l.6-.587a.215.215 0 0 1 .3-.004c.806.703 3.742 2.957 4.059 1.444c.21-1.011.231-5.498-.793-5.168c-.557.18-1.543.977-2.28 1.607c-1.599 1.371-7.243 7.572-8.554 6.844c-1.312-.724-1.63-8.314-.686-9.527z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAxs0",
    x1: 12,
    x2: 12,
    y1: 6.859,
    y2: 17.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAxs1",
    x1: 19.285,
    x2: 4.715,
    y1: 12.001,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8476F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0083EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8763EF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxs);
export default __webpack_public_path__ + "static/media/axs.959d893df769a6cb0ef63ebb58e64d9b.svg";
export { ForwardRef as ReactComponent };